<template>
  <div
    class="table_r w-full justify-start items-center text-[var(--text)] gap-2 p-4 bg-[var(--fundoForm)] rounded-[10px] bg-opacity-[0.55] flex flex-col overflow-x-auto"
    :style="{
      height: '100%',
      paddingTop: styled.noPaddingTop ? '1em' : '2rem',
    }"
    v-if="show && visibility"
  >
    <div class="title_table">
      <div class="title_settings">
        <div
          class="table_title capitalize items-center relative"
          style="display: flex; gap: 1em"
        >
          {{ table_title }}
        </div>

        <!-- Search input -->
        <input
          type="search"
          id="table-search"
          v-model="searchQuery"
          @input="handleSearch"
          placeholder="buscar..."
          ref="searchInput"
        />

        <div class="close_btn_div relative">
          <!-- add a drop down button to export either pdf or csv -->
          <button
            v-if="show_export"
            class="btn"
            @click="toggleDropdown"
          >
            Exportar
            <i v-if="!isDropdownOpen" class="fa-solid fa-caret-down ml-2"></i>
            <i v-else class="fa-solid fa-caret-up ml-2"></i>
          </button>

          <!-- Dropdown menu -->
          <div
            v-if="isDropdownOpen"
            class="w-[6.9rem] text-[var(--text)] absolute top-[2rem] left-0 mt-2 bg-[var(--fundoComponente)] border border-[var(--glass-border)] shadow-lg rounded-md z-10"
          >
            <ul>
              <li
                class="flex items-center justify-between px-4 py-2 hover:bg-[var(--primary)] hover:rounded-md cursor-pointer"
                @click="exportData('pdf')"
              >
                PDF
                <i class="fa-solid fa-file-pdf"></i>
              </li>
              <li
                class="flex items-center justify-between px-4 py-2 hover:bg-[var(--primary)] hover:rounded-md cursor-pointer"
                @click="exportData('csv')"
              >
                CSV
                <i class="fa-solid fa-file-csv"></i>
              </li>
              <li
                class="flex items-center justify-between px-4 py-2 hover:bg-[var(--primary)] hover:rounded-md cursor-pointer"
                @click="exportData('excel')"
              >
                Excel
                <i class="fa-solid fa-file-excel"></i>
              </li>
              <li
                class="flex items-center justify-between px-4 py-2 hover:bg-[var(--primary)] hover:rounded-md cursor-pointer"
                @click="exportData('Email')"
              >
                Email
                <i class="fa-solid fa-envelope"></i>
              </li>
            </ul>
          </div>

          <!-- REFRESH BUTTON -->
          <div class="cursor-pointer" @click="refresh_table">
            <i class="fa-solid fa-arrows-rotate"></i>
          </div>

          <!-- GROUP BY icons -->
          <div v-if="groupby.show && !toggle_groupBy" @click="toggle_groupby">
            <i class="fa-solid fa-bars" style="color: var(--text)"></i>
          </div>
          <div v-if="groupby.show && toggle_groupBy" @click="toggle_groupby">
            <i class="fa-solid fa-grip-vertical" style="color: var(--text)"></i>
          </div>

          <div v-if="filterBtn" @click="$emit('open-filter')">
            <i
              class="fa-solid fa-filter cursor-pointer"
              style="color: var(--text)"
            ></i>
          </div>

          <!-- PER PAGE + FILTER + MULTI-SELECT -->
          <div style="display: flex; gap: 0.5rem; align-items: center">
            <span v-if="!simple">registos:</span>
            <select
              v-model="perPage"
              @change="handlePerPageChange"
              style="
                color: var(--icon);
                border-radius: 0.5rem;
                background-color: var(--fundoComponente);
              "
            >
              <option
                v-for="option in perPageOptions"
                :key="option"
                :value="option"
              >
                {{ option }}
              </option>
            </select>

            <AppTableFilter
              v-if="!simple"
              :filter_data="filter_data"
              @update-filter="updateFilter"
            />

            <div
              v-if="multiSelect.show"
              style="display: flex; align-items: center"
            >
              <input
                type="checkbox"
                id="isMultiSelectCheckbox"
                v-model="isMultiSelect"
                style="margin-right: 0.3rem"
                class="text-blue-500"
              />
              <label for="isMultiSelectCheckbox" style="cursor: pointer">
                Multi-Select
              </label>
            </div>
          </div>

          <!-- SEND BUTTON for multi-select -->
          <div
            v-for="btn in multiSelect.buttons"
            v-if="multiSelect.show && isMultiSelect"
            :key="btn.text"
          >
            <button
              :disabled="!btn.enabled"
              v-if="btn.show"
              @click="sendSelectedRows(btn.emit)"
              class="btn"
              :style="{ backgroundColor: btn.enabled ? btn.color : 'gray' }"
            >
              <!-- add the icon as well in field icon -->
              <i :class="btn.icon" style="color: var(--iconCima)"></i>
              <div style="white-space: nowrap">{{ btn.text }}</div>
            </button>
          </div>

          <!-- CLOSE BUTTON -->
          <!-- <AppButton
            v-bind:visibility="true"
            left_icon="fa-regular fa-circle-xmark fa-xl"
            emitType="close"
            @close="close"
            :width="23"
            :height="23"
            style="color: var(--scroll)"
          /> -->
        </div>
      </div>
    </div>

    <!-- Table -->
    <table class="table-auto w-full md:w-auto">
      <thead>
        <tr>
          <th v-for="key in tableColumns" :key="key">
            {{ handleTableHeader(key) }}
          </th>
          <th v-if="thumbnail">Imagem</th>
          <th v-if="ActionColumn.show" class="w-36 text-center">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(row, rowIndex) in filteredTableData"
          :key="rowIndex"
          @click="rowSelectable ? handleRowClick(row) : null"
          @dblclick="
            rowSelectable && !isMultiSelect ? handleDoubleClick(row, true) : null
          "
          :class="[
            isSelectedRow(row) ? 'selected' : 'nonselected',
            row.status === 'desativado' ? 'row-desativado' : '',
            !rowSelectable ? 'row-nao-selecionavel' : '',
          ]"
        >
          <td
            v-for="key in tableColumns"
            :key="key"
            :style="[getRowStyle(row), getColumnStyle(key)]"
          >
            {{ handleValue(row[key]) }}
          </td>
          <!--  Nova coluna com thumbnail-->
          <!-- nova célula com miniatura -->
          <td v-if="thumbnail" class="text-center">
            <img
              :src="
                row?.thumbnail
                  ? row?.thumbnail
                  : require('@/assets/img/pokemon.png')
              "
              alt="thumbnail"
              width="40"
              height="40"
              class="object-cover rounded-sm"
            />
          </td>
          <!-- Nova coluna com ícones -->
          <td v-if="ActionColumn.show">
            <i
              v-if="ActionColumn.actions?.verDetalhes"
              class="fa-solid fa-eye text-blue-500 cursor-pointer text-lg"
              @click.stop="$emit('view-details', row)"
              v-tooltip="'Visualizar Detalhes'"
            ></i>
            <i
              v-if="ActionColumn.actions?.verPDF"
              class="fa-solid fa-print text-green-500 cursor-pointer text-lg"
              @click.stop="$emit('print-report', row)"
            ></i>
            <i
              v-if="ActionColumn.actions?.verFatura"
              class="fa-solid fa-file-invoice-dollar cursor-pointer text-lg"
              @click.stop="$emit('add-bill', row)"
              :class="row.fatura == 'sim' ? 'text-green-500' : 'text-red-500'"
            ></i>
            <i
              v-if="ActionColumn.actions?.verPlaneamento"
              class="fa-solid fa-calendar-alt text-orange-500 cursor-pointer text-lg"
              @click.stop="$emit('open-planning', row)"
            ></i>
            <i
              v-if="ActionColumn.actions?.verRating && showExtraIcons(row)"
              class="fa-solid fa-star text-yellow-500 cursor-pointer text-lg"
              @click.stop="$emit('open-rating', row)"
            ></i>
            <i
              v-if="ActionColumn.actions?.verObservacoes && showExtraIcons(row)"
              class="fa-solid fa-comment-alt text-blue-500 cursor-pointer text-lg"
              @click.stop="$emit('open-observations', row)"
            ></i>
            <i
              v-if="
                ActionColumn.actions?.verAssinatura &&
                showExtraIcons(row) &&
                row.tipo.toLowerCase() === 'temporário'
              "
              class="fa-solid fa-file-signature text-[var(--text)]-500 cursor-pointer text-lg"
              @click.stop="$emit('open-signature', row)"
            ></i>
            <i
              v-if="ActionColumn.actions?.verOrdem && showExtraIcons(row)"
              class="fas fa-calendar-alt text-[var(--text)]-500 cursor-pointer text-lg"
              @click.stop="$emit('open-ordem', row)"
            ></i>
            <i
              v-if="ActionColumn.actions?.verNegocio"
              class="fas fa-hard-hat text-yellow-500 cursor-pointer text-lg"
              @click.stop="$emit('open-negocio', row)"
            ></i>
          </td>
        </tr>

        <!-- No data -->
        <tr v-if="status == '208'">
          <td
            colspan="100%"
            style="
              width: 100%;
              text-align: center;
              font-size: 2.5em;
              opacity: 0.5;
            "
          >
            Sem dados
          </td>
        </tr>

        <!-- Server Error -->
        <tr v-if="status >= 500 && status < 600">
          <td
            colspan="100%"
            style="
              background-color: red;
              width: 100%;
              text-align: center;
              font-size: 2.5em;
              opacity: 0.5;
            "
          >
            Erro no servidor
          </td>
        </tr>
      </tbody>

      <!-- Loading Popup -->
      <PopupPainel
        v-if="status == 0"
        :loading="true"
        :message="'A carregar dados...'"
        :bg="true"
      />
    </table>

    <!-- Pagination -->
    <div class="w-full grid grid-cols-3 items-center">
      <!-- Left side: registros -->
      <div class="justify-self-start flex gap-4">
        <div class="flex items-center gap-1">
          <label for="total_count">Registos:</label>
          <input
            class="bg-[var(--fundoComponente)] items-center text-center text-[var(--icon)] border border-[var(--glass-border)] p-1 rounded-[5px]"
            type="text"
            id="total_count"
            :value="total_count"
            :size="String(total_count).length || 1"
            readonly
          />
        </div>

        <div class="flex items-center gap-1">
          <label for="total_filter_count">Filtrados:</label>
          <input
            class="bg-[var(--fundoComponente)] items-center text-center text-[var(--icon)] border border-[var(--glass-border)] p-1 rounded-[5px]"
            type="text"
            id="total_filter_count"
            :value="total_filter_count"
            :size="String(total_filter_count).length || 1"
            readonly
          />
        </div>
      </div>

      <!-- Middle: pagination buttons (centered) -->
      <div class="justify-self-center flex items-center gap-2">
        <button
          v-show="currentPage > 1"
          @click="getInitialData"
          style="cursor: pointer; color: var(--scroll)"
        >
          &lt;<i @click.stop="prevPage">&lt;</i>
        </button>
        <span>{{ currentPage }} de {{ endPage }}</span>
        <button
          v-show="currentPage < endPage"
          @click="nextPage"
          style="cursor: pointer; color: var(--scroll)"
        >
          &gt;<i @click.stop="goToFinal">&gt;</i>
        </button>
      </div>

      <!-- Right side: hard hats -->
      <div class="flex items-center justify-end gap-6 justify-self-end">
        <div
          v-if="AddRemoveBtn?.verEquipamento"
          class="relative group cursor-pointer"
          @click.stop="$emit('open-equipamento', null)"
        >
          <HardHat class="text-yellow-500 w-40 h-40" />
          <i
            class="fa-solid fa-fire-extinguisher fa-xl"
            style="color: var(--icon)"
          ></i>
          <!-- Hover popup -->
          <div
            class="absolute hidden w-max max-w-xs bg-[var(--icon)] text-[var(--iconCima)] text-sm rounded p-2 group-hover:block"
            style="
              bottom: 100%;
              left: 50%;
              transform: translateX(-50%) translateY(-10px);
              text-align: center;
            "
          >
            Equipamentos
            <!-- Triangle -->
            <div
              class="absolute w-0 h-0 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-t-[6px] border-t-[var(--icon)]"
              style="top: 100%; left: 50%; transform: translateX(-50%)"
            ></div>
          </div>
        </div>

        <div
          v-if="AddRemoveBtn?.verGPS"
          class="relative group cursor-pointer"
          @click.stop="$emit('open-gps', null)"
        >
          <HardHat class="text-yellow-500 w-40 h-40" />
          <i
            class="fa-solid fa-map-marker-alt fa-xl"
            style="color: var(--icon)"
          ></i>
          <!-- Hover popup -->
          <div
            class="absolute hidden w-max max-w-xs bg-[var(--icon)] text-[var(--iconCima)] text-sm rounded p-2 group-hover:block"
            style="
              bottom: 100%;
              left: 50%;
              transform: translateX(-50%) translateY(-10px);
              text-align: center;
            "
          >
            GPS
            <!-- Triangle -->
            <div
              class="absolute w-0 h-0 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-t-[6px] border-t-[var(--icon)]"
              style="top: 100%; left: 50%; transform: translateX(-50%)"
            ></div>
          </div>
        </div>

        <div
          v-if="AddRemoveBtn?.verComputador"
          class="relative group cursor-pointer"
          @click.stop="$emit('open-computador', null)"
        >
          <HardHat class="text-yellow-500 w-40 h-40" />
          <i class="fa-solid fa-laptop fa-xl" style="color: var(--icon)"></i>
          <!-- Hover popup -->
          <div
            class="absolute hidden w-max max-w-xs bg-[var(--icon)] text-[var(--iconCima)] text-sm rounded p-2 group-hover:block"
            style="
              bottom: 100%;
              left: 50%;
              transform: translateX(-50%) translateY(-10px);
              text-align: center;
            "
          >
            Computador
            <!-- Triangle -->
            <div
              class="absolute w-0 h-0 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-t-[6px] border-t-[var(--icon)]"
              style="top: 100%; left: 50%; transform: translateX(-50%)"
            ></div>
          </div>
        </div>

        <div
          v-if="AddRemoveBtn?.verTPA"
          class="relative group cursor-pointer"
          @click.stop="$emit('open-tpa', null)"
        >
          <HardHat class="text-yellow-500 w-40 h-40" />
          <i
            class="fa-solid fa-credit-card fa-xl"
            style="color: var(--icon)"
          ></i>
          <!-- Hover popup -->
          <div
            class="absolute hidden w-max max-w-xs bg-[var(--icon)] text-[var(--iconCima)] text-sm rounded p-2 group-hover:block"
            style="
              bottom: 100%;
              left: 50%;
              transform: translateX(-50%) translateY(-10px);
              text-align: center;
            "
          >
            TPA
            <!-- Triangle -->
            <div
              class="absolute w-0 h-0 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-t-[6px] border-t-[var(--icon)]"
              style="top: 100%; left: 50%; transform: translateX(-50%)"
            ></div>
          </div>
        </div>
        <div
          v-if="AddRemoveBtn?.verFamilia"
          class="relative group cursor-pointer"
          @click.stop="$emit('open-familia', null)"
        >
          <HardHat class="text-yellow-500 w-40 h-40" />
          <i class="fa-solid fa-sitemap fa-xl" style="color: var(--icon)"></i>
          <!-- Hover popup -->
          <div
            class="absolute hidden w-max max-w-xs bg-[var(--icon)] text-[var(--iconCima)] text-sm rounded p-2 group-hover:block"
            style="
              bottom: 100%;
              left: 50%;
              transform: translateX(-50%) translateY(-10px);
              text-align: center;
            "
          >
            Familia
            <!-- Triangle -->
            <div
              class="absolute w-0 h-0 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-t-[6px] border-t-[var(--icon)]"
              style="top: 100%; left: 50%; transform: translateX(-50%)"
            ></div>
          </div>
        </div>

        <div
          v-if="AddRemoveBtn?.verProduto"
          class="relative group cursor-pointer"
          @click.stop="$emit('open-produto', null)"
        >
          <HardHat class="text-yellow-500 w-40 h-40" />
          <i class="fa-solid fa-box fa-xl" style="color: var(--icon)"></i>
          <!-- Hover popup -->
          <div
            class="absolute hidden w-max max-w-xs bg-[var(--icon)] text-[var(--iconCima)] text-sm rounded p-2 group-hover:block"
            style="
              bottom: 100%;
              left: 50%;
              transform: translateX(-50%) translateY(-10px);
              text-align: center;
            "
          >
            Produto
            <!-- Triangle -->
            <div
              class="absolute w-0 h-0 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-t-[6px] border-t-[var(--icon)]"
              style="top: 100%; left: 50%; transform: translateX(-50%)"
            ></div>
          </div>
        </div>

        <div
          v-if="AddRemoveBtn?.verTipologia"
          class="relative group cursor-pointer"
          @click.stop="$emit('open-tipologia', null)"
        >
          <HardHat class="text-yellow-500 w-40 h-40" />
          <i class="fa-solid fa-tags fa-xl" style="color: var(--icon)"></i>
          <!-- Hover popup -->
          <div
            class="absolute hidden w-max max-w-xs bg-[var(--icon)] text-[var(--iconCima)] text-sm rounded p-2 group-hover:block"
            style="
              bottom: 100%;
              left: 50%;
              transform: translateX(-50%) translateY(-10px);
              text-align: center;
            "
          >
            Tipologia
            <!-- Triangle -->
            <div
              class="absolute w-0 h-0 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-t-[6px] border-t-[var(--icon)]"
              style="top: 100%; left: 50%; transform: translateX(-50%)"
            ></div>
          </div>
        </div>

        <div
          v-if="AddRemoveBtn?.verCliente"
          class="relative group cursor-pointer"
          @click.stop="$emit('open-cliente', null)"
        >
          <HardHat class="text-yellow-500 w-40 h-40" />
          <i class="fa-solid fa-user fa-xl" style="color: var(--icon)"></i>
          <!-- Hover popup -->
          <div
            class="absolute hidden w-max max-w-xs bg-[var(--icon)] text-[var(--iconCima)] text-sm rounded p-2 group-hover:block"
            style="
              bottom: 100%;
              left: 50%;
              transform: translateX(-50%) translateY(-10px);
              text-align: center;
            "
          >
            Cliente
            <!-- Triangle -->
            <div
              class="absolute w-0 h-0 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-t-[6px] border-t-[var(--icon)]"
              style="top: 100%; left: 50%; transform: translateX(-50%)"
            ></div>
          </div>
        </div>

        <div
          v-if="AddRemoveBtn?.verSubCliente"
          class="relative group cursor-pointer"
          @click.stop="$emit('open-subcliente', null)"
        >
          <HardHat class="text-yellow-500 w-40 h-40" />
          <i class="fa-solid fa-users fa-xl" style="color: var(--icon)"></i>
          <!-- Hover popup -->
          <div
            class="absolute hidden w-max max-w-xs bg-[var(--icon)] text-[var(--iconCima)] text-sm rounded p-2 group-hover:block"
            style="
              bottom: 100%;
              left: 50%;
              transform: translateX(-50%) translateY(-10px);
              text-align: center;
            "
          >
            SubCliente
            <!-- Triangle -->
            <div
              class="absolute w-0 h-0 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-t-[6px] border-t-[var(--icon)]"
              style="top: 100%; left: 50%; transform: translateX(-50%)"
            ></div>
          </div>
        </div>

        <div
          v-if="AddRemoveBtn?.verLocalInstalacao"
          class="relative group cursor-pointer"
          @click.stop="$emit('open-localinstalacao', null)"
        >
          <HardHat class="text-yellow-500 w-40 h-40" />
          <i
            class="fa-solid fa-map-marker-alt fa-xl"
            style="color: var(--icon)"
          ></i>
          <!-- Hover popup -->
          <div
            class="absolute hidden w-max max-w-xs bg-[var(--icon)] text-[var(--iconCima)] text-sm rounded p-2 group-hover:block"
            style="
              bottom: 100%;
              left: 50%;
              transform: translateX(-50%) translateY(-10px);
              text-align: center;
            "
          >
            Local Instalação
            <!-- Triangle -->
            <div
              class="absolute w-0 h-0 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-t-[6px] border-t-[var(--icon)]"
              style="top: 100%; left: 50%; transform: translateX(-50%)"
            ></div>
          </div>
        </div>

        <div
          v-if="AddRemoveBtn?.verListaLI"
          class="relative group cursor-pointer"
          @click.stop="$emit('open-listali', null)"
        >
          <HardHat class="text-yellow-500 w-40 h-40" />
          <i
            class="fa-solid fa-file-lines fa-xl"
            style="color: var(--icon)"
          ></i>
          <!-- Hover popup -->
          <div
            class="absolute hidden w-max max-w-xs bg-[var(--icon)] text-[var(--iconCima)] text-sm rounded p-2 group-hover:block"
            style="
              bottom: 100%;
              left: 50%;
              transform: translateX(-50%) translateY(-10px);
              text-align: center;
            "
          >
            Lista de Locais Instalação
            <!-- Triangle -->
            <div
              class="absolute w-0 h-0 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-t-[6px] border-t-[var(--icon)]"
              style="top: 100%; left: 50%; transform: translateX(-50%)"
            ></div>
          </div>
        </div>

        <div
          v-if="AddRemoveBtn?.verConfirmar"
          class="relative group cursor-pointer"
          @click.stop="$emit('open-confirmar', null)"
        >
          <HardHat class="text-yellow-500 w-40 h-40" />
          <i
            class="fa-solid fa-circle-check fa-xl"
            style="color: var(--icon)"
          ></i>
          <!-- Hover popup -->
          <div
            class="absolute hidden w-max max-w-xs bg-[var(--icon)] text-[var(--iconCima)] text-sm rounded p-2 group-hover:block"
            style="
              bottom: 100%;
              left: 50%;
              transform: translateX(-50%) translateY(-10px);
              text-align: center;
            "
          >
            Confirmar
            <!-- Triangle -->
            <div
              class="absolute w-0 h-0 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-t-[6px] border-t-[var(--icon)]"
              style="top: 100%; left: 50%; transform: translateX(-50%)"
            ></div>
          </div>
        </div>

        <div
          v-if="AddRemoveBtn?.verDefault"
          class="relative group cursor-pointer"
          @click.stop="$emit('open-default', null)"
        >
          <HardHat class="text-yellow-500 w-40 h-40" />
          <i
            class="fa-solid fa-group-arrows-rotate fa-xl"
            style="color: var(--icon)"
          ></i>
          <!-- Hover popup -->
          <div
            class="absolute hidden w-max max-w-xs bg-[var(--icon)] text-[var(--iconCima)] text-sm rounded p-2 group-hover:block"
            style="
              bottom: 100%;
              left: 50%;
              transform: translateX(-50%) translateY(-10px);
              text-align: center;
            "
          >
            Padrão
            <!-- Triangle -->
            <div
              class="absolute w-0 h-0 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-t-[6px] border-t-[var(--icon)]"
              style="top: 100%; left: 50%; transform: translateX(-50%)"
            ></div>
          </div>
        </div>

        <!-- Adicionar (verde) -->
        <div
          v-if="AddRemoveBtn?.verAdicionar"
          class="relative group cursor-pointer"
          @click.stop="$emit('open-adicionar', null)"
        >
          <HardHat class="text-yellow-500 w-40 h-40" />
          <i
            class="fa-solid fa-circle-plus fa-xl"
            style="color: var(--icon)"
          ></i>

          <!-- Hover popup -->
          <div
            class="absolute hidden w-max max-w-xs bg-[var(--icon)] text-[var(--iconCima)] text-sm rounded p-2 group-hover:block"
            style="
              bottom: 100%;
              left: 50%;
              transform: translateX(-50%) translateY(-10px);
              text-align: center;
            "
          >
            Adicionar
            <!-- Triangle -->
            <div
              class="absolute w-0 h-0 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-t-[6px] border-t-[var(--icon)]"
              style="top: 100%; left: 50%; transform: translateX(-50%)"
            ></div>
          </div>
        </div>

        <!-- Adicionar (verde) -->
        <div
          v-if="AddRemoveBtn?.verRapido"
          class="relative group cursor-pointer"
          @click.stop="$emit('open-rapido', null)"
        >
          <HardHat class="text-yellow-500 w-40 h-40" />
          <i class="fa-solid fa-bolt fa-xl" style="color: var(--icon)"></i>

          <!-- Hover popup -->
          <div
            class="absolute hidden w-max max-w-xs bg-[var(--icon)] text-[var(--iconCima)] text-sm rounded p-2 group-hover:block"
            style="
              bottom: 100%;
              left: 50%;
              transform: translateX(-50%) translateY(-10px);
              text-align: center;
            "
          >
            Rápido
            <!-- Triangle -->
            <div
              class="absolute w-0 h-0 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-t-[6px] border-t-[var(--icon)]"
              style="top: 100%; left: 50%; transform: translateX(-50%)"
            ></div>
          </div>
        </div>

        <!-- Retirar (vermelho) -->
        <div
          v-if="AddRemoveBtn?.verRetirar"
          class="relative group cursor-pointer"
          @click.stop="$emit('open-retirar', this.getSelectedRow())"
        >
          <HardHat class="text-yellow-500 w-40 h-40" />
          <i class="fa-solid fa-trash fa-xl" style="color: var(--obrigatorio)"></i>

          <!-- Hover popup -->
          <div
            class="absolute hidden w-max max-w-xs bg-[var(--icon)] text-[var(--iconCima)] text-sm rounded p-2 group-hover:block"
            style="
              bottom: 100%;
              left: 50%;
              transform: translateX(-50%) translateY(-10px);
              text-align: center;
            "
          >
            Remover
            <!-- Triangle -->
            <div
              class="absolute w-0 h-0 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-t-[6px] border-t-[var(--icon)]"
              style="top: 100%; left: 50%; transform: translateX(-50%)"
            ></div>
          </div>
        </div>

        <div
          v-if="AddRemoveBtn?.verHistorico"
          class="relative group cursor-pointer"
          @click.stop="$emit('open-historico', null)"
        >
          <HardHat class="text-yellow-500 w-40 h-40" />
          <i class="fa-solid fa-newspaper fa-xl" style="color: var(--icon)"></i>
          <!-- Hover popup -->
          <div
            class="absolute hidden w-max max-w-xs bg-[var(--icon)] text-[var(--iconCima)] text-sm rounded p-2 group-hover:block"
            style="
              bottom: 100%;
              left: 50%;
              transform: translateX(-50%) translateY(-10px);
              text-align: center;
            "
          >
            Histórico
            <!-- Triangle -->
            <div
              class="absolute w-0 h-0 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-t-[6px] border-t-[var(--icon)]"
              style="top: 100%; left: 50%; transform: translateX(-50%)"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ConfirmPopUp
    ref="myConfirm"
    @accept="onAccept"
    @accept-one="AcceptOne"
    @accept-both="onAcceptBoth"
    :message="confirmationProps.message"
  />
</template>

<script>
import { nextTick } from "vue";
import axios from "axios";
import AppButton from "@/components/button.vue";
import AppTableFilter from "@/components/filter/tableFilter.vue";
import ConfirmPopUp from "@/components/modals/MyConfirmPopUp.vue";
import PopupPainel from "@/components/_popupPainel.vue";
import { toast } from "vue3-toastify";

export default {
  name: "AppTablePagnation",
  components: {
    AppButton,
    AppTableFilter,
    ConfirmPopUp,
    PopupPainel,
  },
  props: {
    // Permite desligar a seleção de linhas em tabelas só de consulta.
    rowSelectable: {
      type: Boolean,
      default: true,
    },
    columnWidths: {
      type: Object,
      default: () => ({}),
    },
    checkStatusTipo: {
      type: Boolean,
      default: false,
    },
    queryCampo: {
      type: Object,
      default: () => ({
        campo: null,
        valor: null,
      }),
    },
    refresh: {
      type: Boolean,
      default: false,
    },
    styled: {
      type: Object,
      default: () => ({}),
    },
    hiden: {
      type: Object,
      default: () => ({
        status: false,
      }),
    },
    finalUrl: {
      type: String,
      default: "l=1",
    },
    specialKey: {
      type: String,
      default: null,
    },
    page_display: {
      type: Number,
      default: 15,
    },
    simple: {
      type: Boolean,
      default: false,
    },
    btn_criar: {
      type: Object,
      default: () => ({
        show: false,
        form: "0",
      }),
    },
    status: {
      type: String,
      default: "200",
    },
    confirmationProps: {
      type: Object,
      default: () => ({
        show: false,
        message: "Deseja adicionar este item?",
      }),
    },
    table_title: {
      type: String,
      default: "Table Title",
    },
    show: {
      type: Boolean,
      default: false,
    },
    visibility: {
      type: Boolean,
      default: false,
    },
    urlString: {
      type: String,
      required: true,
    },
    with_confirmation: {
      type: Boolean,
      default: false,
    },
    notificacao: {
      type: Object,
      default: () => ({}),
    },
    pickKey: {
      type: Array,
      default: () => [],
    },
    hiddenColumns: {
      type: Array,
      default: () => [
        "id",
        "localinstalacao_id",
        "cliente_id",
        "subcliente_id",
        "subCliente_id",
        "numero",
        "instalacao_id",
        "fatura",
        "ordemServico_id",
        "familia_id",
        "tpMoeda_id",
        "equipamento_id",
        "equipamento_nome",
        "vendaMin",
        "compraMed",
        "compraAtual",
        "compraMin"

      ],
    },
    groupby: {
      type: Object,
      default: () => ({
        show: false,
        field: "",
        toggle: true,
      }),
    },
    filterBtn: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    static_data: {
      type: Array,
      default: () => [],
    },
    ActionColumn: {
      type: Object,
      default: () => ({
        show: false,
        action: {
          verDetalhes: false,
          verPDF: false,
          verFatura: false,
          verPlaneamento: false,
        },
      }),
    },
    AddRemoveBtn: {
      type: Object,
      default: () => ({ verAdicionar: false, verRetirar: false }),
    },
    show_export: {
      type: Boolean,
      default: true,
    },
    multiSelect: {
      type: Object,
      default: () => ({
        show: false,
        isActive: false,
        buttons: {
          add: {
            show: false,
            enabled: false,
            text: "Adicionar",
            color: "green",
            icon: "fa-solid fa-plus",
            emit: "send-selected-rows",
          },
          remove: {
            show: false,
            enabled: false,
            text: "Remover",
            color: "red",
            icon: "fa-solid fa-minus",
            emit: "remove-selected-rows",
          },
        },
      }),
    },
    searchBy: {
      type: String,
      default: "",
    },
    specialQuery: {
      type: Object,
      default: () => ({}),
    },

    thumbnail: {
      type: Boolean,
      default: false, // não mostra miniaturas por defeito
    },
  },
  data() {
    return {
      perPage: this.page_display,
      currentPage: 0,
      endPage: 0,
      baseURL: process.env.VUE_APP_URL_BASE || "https://mysafety.gruposafety.pt",
      selectedRow: {},
      isMultiSelect: this.multiSelect.isActive,
      toggle_groupBy: false,
      selectedRows: [],
      isDropdownOpen: false,
      searchQuery: "",
      table_data: [],
      perPageOptions: [5, 10, 15, 20, 25, 30],
      filter_data: {},
      paginationLinks: {
        next: null,
        previous: null,
      },
      total_count: 0,
      total_filter_count: 0,
      // We'll use this to debounce getInitialData calls.
      debounceTimer: null,
    };
  },

  // 1) A single computed property that returns everything that might trigger a re-fetch:
  computed: {
    watchProps() {
      return {
        queryCampo: this.queryCampo,
        data: this.data,
        urlString: this.urlString,
        refresh: this.refresh,
        groupby: this.groupby,
        static_data: this.static_data,
        perPage: this.perPage,
        page_display: this.page_display,
        searchBy: this.searchBy,
        specialQuery: this.specialQuery,
      };
    },
    filteredTableData() {
      return this.table_data.filter((row) => {
        return Object.keys(this.filter_data).every((key) => {
          return this.filter_data[key]
            ? row[key] === this.filter_data[key]
            : true;
        });
      });
    },
    tableColumns() {
      if (this.filteredTableData.length > 0) {
        return Object.keys(this.filteredTableData[0]).filter(
          (key) => !this.hiddenColumns.includes(key)
        );
      }
      return [];
    },
  },

  // 2) A single watch on that computed property:
  watch: {
    watchProps: {
      handler(newVal, oldVal) {
        // If static_data changed, just override table_data with it
        if (newVal.static_data !== oldVal.static_data) {
          this.table_data = newVal.static_data;
        }

        // If groupby.toggle changed, update toggle_groupBy & re-fetch
        if (newVal.groupby.toggle !== oldVal.groupby.toggle) {
          this.toggle_groupBy = newVal.groupby.toggle;
          this.getInitialData();
          return;
        }

        // If refresh changed from false -> true
        if (newVal.refresh && !oldVal.refresh) {
          this.getInitialData();
          this.$emit("update:refresh", false);
          return;
        }

        // If queryCampo, data, or urlString changed => re-fetch
        const changedQueryCampo =
          newVal.queryCampo.campo !== oldVal.queryCampo.campo ||
          newVal.queryCampo.valor !== oldVal.queryCampo.valor;
        const changedUrlString = newVal.urlString !== oldVal.urlString;
        const changedData =
          JSON.stringify(newVal.data) !== JSON.stringify(oldVal.data);

        if (changedQueryCampo || changedUrlString || changedData) {
          this.getInitialData();
        }

        if (newVal.page_display !== oldVal.page_display) {
          this.perPage = this.page_display;
          this.getInitialData();
        } else if (newVal.perPage !== oldVal.perPage) {
          this.getInitialData();
        } else {
          this.perPage = this.page_display;
          this.getInitialData();
        }

        if (newVal.specialQuery !== oldVal.specialQuery) {
          this.getInitialData();
        }
      },
      deep: true,
      immediate: false, // We'll do initial load in mounted instead
    },
  },

  mounted() {
    this.getInitialData(); // load data once on mount

    this.$nextTick(() => {
      if (this.$refs.searchInput) {
        this.$refs.searchInput.focus();
      }
    });
  },

  methods: {
    showExtraIcons(row) {
      if (!this.checkStatusTipo) {
        return true;
      }
      return row.tipo && row.tipo.toLowerCase() === "temporário";
    },
    sanitizeURL(link) {
      if (!link) return null;
      try {
        const parsed = new URL(link);

        const devMode =
          window.location.hostname.startsWith("localhost") ||
          window.location.hostname.startsWith("192.") ||
          window.location.hostname === "127.0.0.1";

        if (window.location.hostname === parsed.hostname) {
          return link;
        }

        if (devMode) {
          // Mantém a porta do backend (ex: 8000), mas troca o hostname
          return `${window.location.protocol}//${window.location.hostname}:${parsed.port}${parsed.pathname}${parsed.search}`;
        }

        // Produção — mantém caminho, substitui por o domínio atual
        return `${window.location.origin}${parsed.pathname}${parsed.search}`;
      } catch (err) {
        console.warn("URL malformada:", link);
        return link;
      }
    },

    // main fetch method (GET or POST depending on data)
    async fetchData(url, params = {}) {
      try {
        const isEmptyObject = (obj) =>
          !obj || typeof obj !== "object" || Object.keys(obj).length === 0;

        let response;
        if (isEmptyObject(this.data)) {
          response = await axios.get(url, { params });
        } else {
          response = await axios.post(url, this.data, { params });
        }

        if (response.data) {
          this.total_count = response.data.count || 0;
          this.total_filter_count = response.data.total_count || 0;
          this.currentPage = response.data.current_page;
          this.endPage = response.data.end_page;
          this.paginationLinks = {
            next: this.sanitizeURL(response.data?.links?.next),
            previous: this.sanitizeURL(response.data?.links?.previous),
          };
          this.table_data = response.data.results || [];
        } else {
          this.table_data = [];
        }
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
        this.table_data = [];
      }
    },

    // build URL, set up params, call fetchData
    async getInitialData() {
      if (this.static_data.length > 0) {
        this.table_data = this.static_data;
        return;
      }
      let url = "";
      if (this.groupby.show) {
        if (this.toggle_groupBy) {
          url = `${this.baseURL}/api/v1/${this.urlString}/pagination/groupby/${this.groupby.field}/`;
        } else {
          url = `${this.baseURL}/api/v1/${this.urlString}/pagination/`;
        }
      } else {
        url = `${this.baseURL}/api/v1/${this.urlString}/pagination/`;
      }
      const params = {
        search: this.searchQuery,
        page_size: this.perPage,
      };
      
      if (this.queryCampo.campo && this.queryCampo.valor) {
        params.campo = this.queryCampo.campo;
        params.valor = this.queryCampo.valor;
      }
      if (this.finalUrl) {
        const splitted = this.finalUrl.split("&");
        splitted.forEach((pair) => {
          const [k, v] = pair.split("=");
          params[k] = v;
        });
      }

      await this.fetchData(url, params);
      this.$emit("refreshed");
    },

    async goToFinal() {
      const lastPageUrl = `${this.baseURL}/api/v1/${this.urlString}/pagination/?page=${this.endPage}`;
      const params = {
        search: this.searchQuery,
        page_size: this.perPage,
      };
      if (this.queryCampo.campo && this.queryCampo.valor) {
        params.campo = this.queryCampo.campo;
        params.valor = this.queryCampo.valor;
      }
      if (this.finalUrl) {
        const splitted = this.finalUrl.split("&");
        splitted.forEach((pair) => {
          const [k, v] = pair.split("=");
          params[k] = v;
        });
      }
      await this.fetchData(lastPageUrl, params);
    },

    async nextPage() {
      if (this.paginationLinks.next) {
        await this.fetchData(this.paginationLinks.next);
      }
    },

    async prevPage() {
      if (this.paginationLinks.previous) {
        await this.fetchData(this.paginationLinks.previous);
      }
    },

    async handleSearch() {
      await this.getInitialData();
    },

    async handlePerPageChange() {
      await this.getInitialData();
    },

    updateFilter({ property, value }) {
      this.filter_data[property] = value;
    },

    toggle_groupby() {
      this.toggle_groupBy = !this.toggle_groupBy;
      this.getInitialData();
    },

    refresh_table() {
      this.getInitialData();
    },

    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },

    exportData(type) {
      this.toggleDropdown();
      if (type === "Email") {
        toast.error("Esta funcionalidade ainda não está disponível.");
        return;
      }
      const baseUrl = `${this.baseURL}/api/v1/${this.urlString}/pagination/`;

      const downloadFile = (blobData, fileType) => {
        const blobUrl = window.URL.createObjectURL(blobData);
        const link = document.createElement("a");
        link.href = blobUrl;
        const extension = fileType === "excel" ? "xlsx" : fileType;
        link.setAttribute("download", `dados_export.${extension}`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(() => window.URL.revokeObjectURL(blobUrl), 100);
      };

      const sendExportRequest = (method, url, data = {}) => {
        return axios({
          method,
          url,
          [method === "get" ? "params" : "data"]: data,
          responseType: "blob",
        });
      };

      const hasBodyFilters = Object.keys(this.data || {}).length > 0;
      if (hasBodyFilters) {
        const filters = {
          ...this.data,
          search: this.searchQuery || "",
          export: type,
        };
        // If this.queryCampo has both campo and valor, add them.
        if (this.queryCampo && this.queryCampo.campo && this.queryCampo.valor) {
          filters.campo = this.queryCampo.campo;
          filters.valor = this.queryCampo.valor;
        }
        sendExportRequest("post", baseUrl, filters)
          .then((resp) => downloadFile(resp.data, type))
          .catch((err) => console.error("Export error (POST):", err));
      } else {
        // Build query parameters for GET requests.
        const params = new URLSearchParams();
        params.append("export", type);
        params.append("search", this.searchQuery || "");
        // Append this.queryCampo values if they exist.
        if (this.queryCampo && this.queryCampo.campo && this.queryCampo.valor) {
          params.append("campo", this.queryCampo.campo);
          params.append("valor", this.queryCampo.valor);
        }
        const exportUrl = `${baseUrl}?${params.toString()}`;
        sendExportRequest("get", exportUrl)
          .then((resp) => downloadFile(resp.data, type))
          .catch((err) => console.error("Export error (GET):", err));
      }
    },

    handleDoubleClick(row) {
      this.$emit("row-dClicked", row);
    },
    handleRowClick(row) {
      if (this.isMultiSelect) {
        const index = this.selectedRows.findIndex((r) => r.id === row.id);
        if (index === -1) {
          this.selectedRows.push(row);
        } else {
          this.selectedRows.splice(index, 1);
        }
        nextTick(() => {
          this.$forceUpdate();
        });
        this.$emit("multiRow-clicked", this.selectedRows);
      } else {
        this.selectedRow = row;
        this.$emit("row-clicked", row);
      }
    },
    handleTableHeader(key) {
      if (typeof key == "string") {
        if (key.toLocaleLowerCase() === "localinstalacao")
          return "Local de Instalação";
        if (key.toLocaleLowerCase() === "contactocliente") return "contacto";
        if (key.toLocaleLowerCase() === "modocontato") return "Modo de Contato";
        if (key.toLocaleLowerCase() === "iva_num") return "Iva Absoluto";
        if (key.toLocaleLowerCase() === "negocio_id") return "Negócio";
        if (key.toLocaleLowerCase() === "tpiva_id") return "Iva";
      }
      return key.replace(/([A-Z])/g, " $1").toLowerCase();
    },
    handleValue(value) {
      if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}T/.test(value)) {
        const datePart = value.substring(0, 10);
        const timePart = value.substring(11, 16);
        return `${datePart} ${timePart}`;
      }

      if (typeof value === "object" && value !== null) {
        // ✅ Handle different object structures
        if (value.nome) return value.nome; // For familia objects
        if (value.produto) return value.produto; // For produto objects
        if (value.user) return value.user; // For user objects

        // ✅ Fallback: try to find a reasonable display value
        const displayKeys = ["name", "title", "description", "codigo"];
        for (const key of displayKeys) {
          if (value[key]) return value[key];
        }

        // ✅ Last resort: show JSON but truncated
        return JSON.stringify(value).substring(0, 50) + "...";
      }

      if (value === null) {
        return "N/A";
      }

      return value;
    },
    isSelectedRow(row) {
      return this.isMultiSelect
        ? this.selectedRows.some((r) => r.id === row.id)
        : this.selectedRow.id === row.id;
    },
    sendSelectedRows(emit_type) {
      this.$emit(
        emit_type,
        this.selectedRows.sort((a, b) => a.id - b.id)
      );
    },

    getSelectedRow() {
      return this.isMultiSelect ? this.selectedRows : this.selectedRow;
    },

    getRowStyle(row) {
      if (this.table_title === "Notificação") {
        return {
          backgroundColor: row.cor,
        };
      } else {
        return {
          backgroundColor: row.status === "desativado" ? "var(--icon)" : "",
        };
      }
    },
    getColumnStyle(key) {
      if (this.columnWidths[key]) {
        return {
          minWidth: this.columnWidths[key],
          maxWidth: this.columnWidths[key],
          width: this.columnWidths[key],
        };
      }
      return {};
    },
    close() {
      this.$emit("close");
    },

    // Optional: ConfirmPopUp handlers
    onAccept() {},
    AcceptOne() {},
    onAcceptBoth() {},
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Abril+Fatface&family=Inter&family=Montserrat:wght@600&family=Poppins:wght@600&display=swap");

/* Example row highlighting if row.status=desativado */
.row-desativado td {
  background-color: var(--obrigatorio) !important;
}

.table_wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background-color: var(--fundoForm);
  padding: 2rem;
  border-radius: 8px;
  justify-content: flex-start;
  align-items: center;
  color: var(--label);
  overflow-x: auto;
}

.title_table {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.title_settings {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}

.table_title {
  font-size: 16px;
  color: var(--titulo);
}

.close_btn_div {
  display: flex;
  align-self: flex-end;
  justify-content: center;
  align-items: center;
  gap: 1rem;
}

.table_r table {
  color: var(--label);
  /* remove table-layout fixed for flexible columns */
  width: 100%;
  max-height: 253px;
  overflow-y: auto;
  overflow-x: auto;
  gap: 1rem;
  border-collapse: separate;
  border-spacing: 0 0.3em;
}

thead {
  background-color: var(--colunaLista);
  width: 100%;
  height: 25px;
  border-radius: 8px;
}

th {
  font-size: 14px;
  text-align: left;
  padding-left: 0.5rem;
  text-transform: capitalize;
  font-weight: 400;
}

tbody {
  width: 100%;
}

tbody tr {
  height: 25px;
  cursor: pointer;
  margin-bottom: 1em;
}

tbody tr.row-nao-selecionavel {
  cursor: default;
}

/* Hover color */
tbody tr:hover td {
  background: var(--scroll);
  color: var(--linhaLista);
  text-shadow: 0 0 0.5px currentColor, 0 0 1px currentColor;
}

/* Non-selected row style */
.nonselected td {
  background-color: var(--linhaLista);
  font-size: 12px;
  text-align: left;
  padding-left: 0.5rem;
  border: none;
}

/* Selected row style */
.selected td {
  background-color: var(--scroll);
  color: var(--linhaLista);
  font-size: 12px;
  text-align: left;
  padding-left: 0.5rem;
  border: none;
  text-shadow: 0 0 0.5px currentColor, 0 0 1px currentColor;
}

/* Round corners for first & last cell */
td:first-child,
th:first-child {
  border-radius: 8px 0 0 8px;
}
td:last-child,
th:last-child {
  border-radius: 0 8px 8px 0;
}

/* Search input */
#table-search {
  height: 30px;
  width: 250px;
  border-radius: 8px;
  background-color: var(--fundoApp);
  color: var(--label);
  padding: 10px 15px;
  border: none;
  outline: none;
}

/* Word-wrapping for large content */
td,
th {
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

/* Responsive text sizes */
@media (max-width: 768px) {
  .table_wrapper {
    font-size: 0.8em;
  }
}

@media (min-width: 769px) {
  .table_wrapper {
    font-size: 1em;
  }
}
</style>
